import { login, logout } from '@/api/auth'
import { PcCookie, Key } from '@/utils/cookie'
// 对 cookie 操作 // 定义状态，state必须是function

const state = {
    userInfo: PcCookie.get(Key.userInfoKey) ? PcCookie.get(Key.userInfoKey) : null, // 用户信息对象
    jsessId: PcCookie.get(Key.jsessIdKey), // 访问令牌字符串
    signId: PcCookie.get(Key.signKey),
}
// 改变状态值
const mutations = {
    // 赋值用户状态
    SET_USER_STATE(state, data) {
        // 状态赋值
        const { username, JSESSIONID, sign } = data
        state.userInfo = username
        state.jsessId = JSESSIONID
        state.signId = sign
        // 保存到cookie中
        PcCookie.set(Key.userInfoKey, username)
        PcCookie.set(Key.jsessIdKey, JSESSIONID)
        PcCookie.set(Key.signKey, sign)
    },
    // 重置用户状态,退出和登录失败时用
    RESET_USER_STATE(state) {
        // 状态置空
        //state.userInfo = null
        state.jsessId = null
        state.signId = null
        // 移除cookie
        //PcCookie.remove(Key.userInfoKey)
        PcCookie.remove(Key.jsessIdKey)
        PcCookie.remove(Key.signKey)
    },
}
// 定义行为
const actions = {
    // 登录操作 ++++++++++++++++++++++++++ 4.
    UserLogin({ commit }, loginNews) {

        return new Promise((resolve, reject) => {
            // 调用登录接口 /api/auth.js#login
            login(loginNews.userInfo).then(response => {
                // 获取响应值
                const { body, success } = response
                if (success) {
                    // 状态赋值
                    if (loginNews.checked) {
                        PcCookie.set(Key.checkedKey, true)
                    } else {
                        PcCookie.set(Key.checkedKey, false)
                    }
                    commit('SET_USER_STATE', body)
                }
                resolve(response)
                // 不要少了
            }).catch(error => {
                // 重置状态
                commit('RESET_USER_STATE')
                reject(error)
            })
        })
    },
    UserLogout({ state, commit }) {
        // 调用退出接口, 上面不要忘记导入 logout 方法
        return new Promise((resolve, reject) => {
            logout(state.jsessId).then((response) => {
                // 获取响应值
                const { success } = response
                if (success) {
                    // 状态赋值
                    commit('RESET_USER_STATE')
                    if (PcCookie.get(Key.checkedKey) === 'false') {
                        PcCookie.remove(Key.passKey)
                        PcCookie.remove(Key.codeKey)
                        PcCookie.remove(Key.userInfoKey)
                    }
                    PcCookie.remove(Key.headImgKey)
                    PcCookie.remove(Key.checkedKey)
                }
                resolve(response)
                // 不要少了
            }).catch(error => {
                // 重置状态
                //commit('RESET_USER_STATE')
                reject(error)
            })
        })
    },
    //修改密码后清除
    clearAuthNews({commit }){
        commit('RESET_USER_STATE');
        PcCookie.remove(Key.userInfoKey)
        PcCookie.remove(Key.headImgKey)
        PcCookie.remove(Key.checkedKey)
    }
}
export default { state, mutations, actions }
